import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1014bbfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger d-flex flex-nowrap overflow-hidden"
}
const _hoisted_5 = { class: "text-nowrap mr-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle" }, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "spacing-column" }
const _hoisted_9 = { class: "my-1 text-bold text-right text-lg-left" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { style: {"line-height":"1.25rem"} }
const _hoisted_12 = { class: "d-flex justify-content-end flex-grow-1" }
const _hoisted_13 = { class: "row-expansion-content" }
const _hoisted_14 = { class: "d-flex align-items-center product-name-wrapper" }
const _hoisted_15 = { class: "d-flex flex-column align-items-end align-items-lg-start" }
const _hoisted_16 = {
  key: 0,
  class: "mb-0 text-bold text-right text-lg-left"
}
const _hoisted_17 = ["href", "title"]
const _hoisted_18 = {
  key: 1,
  class: "mb-0 text-bold text-right text-lg-left"
}
const _hoisted_19 = { class: "badge badge-primary multi-user-badge" }
const _hoisted_20 = { class: "my-1 text-bold text-right text-lg-left" }
const _hoisted_21 = { class: "lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_AvatarGroup = _resolveComponent("AvatarGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.shouldShowTopLevelContractExpirationWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t("myCadac.contractOverview.subscription.expirationWarning.title")), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('myCadac.contractOverview.subscription.expirationWarning.text')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.subscriptions.length)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          "auto-layout": "",
          "expanded-rows": _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expandedRows) = $event)),
          "responsive-layout": "stack",
          breakpoint: "991px",
          "row-class": _ctx.highlightRow,
          value: _ctx.subscriptions,
          class: "subscription-table"
        }, {
          expansion: _withCtx((item) => [
            _createElementVNode("div", _hoisted_13, [
              (item?.data?.autodeskContractAssets?.length)
                ? (_openBlock(), _createBlock(_component_DataTable, {
                    key: 0,
                    value: item?.data?.autodeskContractAssets
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "productName",
                        class: "name-column",
                        header: _ctx.$t('myCadac.contractOverview.table.colProductName'),
                        sortable: false
                      }, {
                        body: _withCtx((asset) => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_Avatar, {
                              alt: asset.data.productIconAlt,
                              class: "mr-1 bg-transparent flex-shrink-0 d-none d-lg-block",
                              image: asset.data.productIconUrl,
                              shape: "square",
                              size: "large",
                              title: asset.data.productName
                            }, null, 8, ["alt", "image", "title"]),
                            _createElementVNode("div", _hoisted_15, [
                              (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                                    _createElementVNode("a", {
                                      href: asset.data.productCrmUrl,
                                      target: "_blank",
                                      title: _ctx.$t('common.goToCrm')
                                    }, _toDisplayString(_ctx.formatProductName(asset.data.productName, asset.data.productBrand)), 9, _hoisted_17)
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.formatProductName(asset.data.productName, asset.data.productBrand)), 1)),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(asset.data.multiSizeUnitString), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["header"]),
                      _createVNode(_component_Column, {
                        style: {"width":"15%"},
                        field: "seats",
                        header: _ctx.$t('myCadac.contractOverview.table.colProductSeats'),
                        sortable: false
                      }, {
                        body: _withCtx((asset) => [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_20, _toDisplayString(asset.data.seats), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["header"])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                : (_openBlock(), _createBlock(_component_Message, {
                    key: 1,
                    closable: false,
                    severity: "warn"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("myCadac.contractOverview.message.noContractAssets")), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { expander: "" }),
            _createVNode(_component_Column, {
              key: "endDate",
              field: "endDate",
              class: "end-date-column",
              style: {"width":"25%"},
              header: _ctx.$t('myCadac.contractOverview.table.colExpiresOn'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                (_ctx.shouldShowContractExpirationWarning(item.data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1),
                      _createVNode(_component_PopoverIcon, {
                        class: "d-inline-flex",
                        style: {"line-height":"1.75rem"}
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$tc("myCadac.contractOverview.table.contractExpirationWarning", {
										count: item.data.remainingDays,
									})), 1)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1))
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "products",
              field: "products",
              style: {"width":"25%"},
              header: _ctx.$t('myCadac.contractOverview.table.colProducts'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                _createVNode(_component_AvatarGroup, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedSubscriptionAsset(item.data)?.slice(
							0,
							_ctx.maxContractAssetsToShow
						), (asset, index) => {
                      return (_openBlock(), _createBlock(_component_Avatar, {
                        key: index,
                        alt: asset.productIconAlt,
                        class: "ml-0 bg-transparent",
                        image: asset.productIconUrl,
                        shape: "square",
                        size: "small",
                        title: asset.productName
                      }, null, 8, ["alt", "image", "title"]))
                    }), 128)),
                    (item.data.autodeskContractAssets?.length > _ctx.maxContractAssetsToShow)
                      ? (_openBlock(), _createBlock(_component_Avatar, {
                          key: 0,
                          class: "text-bold ml-0",
                          label: `+${item.data.autodeskContractAssets?.length - _ctx.maxContractAssetsToShow}`,
                          shape: "square",
                          size: "small"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "renewalTerm",
              field: "duration",
              style: {"width":"15%"},
              header: _ctx.$t('myCadac.contractOverview.table.colDuration'),
              sortable: false
            }, {
              body: _withCtx((assetDuration) => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(assetDuration.data.duration), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "automaticRenewal",
              field: "automaticRenewal",
              style: {"width":"15%"},
              header: _ctx.$t('myCadac.contractOverview.table.colAutomaticRenewal'),
              sortable: false
            }, {
              body: _withCtx((item) => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("i", {
                    class: _normalizeClass(item.data.automaticRenewal
						? 'pi pi-check text-success mr-1'
						: 'pi pi-times text-danger mr-1'
						)
                  }, null, 2),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getAutomaticRenewalText(item.data.automaticRenewal)), 1)
                ])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              key: "actions",
              style: {"width":"20%"}
            }, {
              body: _withCtx((item) => [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.shouldShowContractExpirationWarning(item.data))
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-success p-button-sm mt-1",
                        label: _ctx.$t('myCadac.contractOverview.subscription.expirationWarning.buttonText'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.openUrl(_ctx.vm.contactPageUrl, '_blank');
                                    $event.target.disabled = true;})
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["expanded-rows", "row-class", "value"]))
      : _createCommentVNode("", true),
    (!_ctx.subscriptions.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 2,
          class: "mx-auto mt-2"
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("myCadac.contractOverview.card.noContracts")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}